import Marquee from "react-fast-marquee";

const partners = [
  { name: "WANKAI NEW MATERIAL", logo: "/brand/wkai.png" },
  { name: "ANGEL YEAST", logo: "/brand/angel.png" },
  { name: "EPLASTMER", logo: "/brand/eplastmer.png" },
  { name: "NEPTUNE LOGISTICS", logo: "/brand/neptune.png" },
];

export default function EditorialMarquee() {
  return (
    <div data-testid="marquee" className="border-y border-black/10 bg-[#f6f6f4] py-8 overflow-hidden">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 mb-6 flex items-center gap-4">
        <span className="h-px w-8 bg-[#d81f2a]" />
        <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#5b6472]">
          Güvenilir İş Ortaklarımız / Trusted Partners
        </span>
      </div>
      <Marquee speed={45} gradient gradientColor="#f6f6f4" gradientWidth={80} pauseOnHover>
        {partners.concat(partners).map((p, i) => (
          <div
            key={i}
            data-testid="marquee-logo"
            className="mx-6 flex items-center gap-4 border border-black/10 bg-white px-8 py-5 group hover:border-[#d81f2a]/40 transition-colors"
          >
            <img src={p.logo} alt={`${p.name} logo`} className="h-10 w-auto max-w-[130px] object-contain grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100 transition-all" />
            <span className="font-display text-sm font-bold uppercase tracking-tight text-[#0f1115] whitespace-nowrap">
              {p.name}
            </span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
